/**
 * Auth storage using sessionStorage so the user is logged out when the tab/browser is closed.
 * All token and OTP user info access goes through this module.
 */

const TOKEN_KEY = 'firebase_token';
const OTP_USER_INFO_KEY = 'otp_user_info';

export function getAuthToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  if (token != null) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
}

export function clearAuthToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function getOtpUserInfo() {
  try {
    const raw = sessionStorage.getItem(OTP_USER_INFO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setOtpUserInfo(data) {
  if (data != null) {
    sessionStorage.setItem(OTP_USER_INFO_KEY, JSON.stringify(data));
  } else {
    sessionStorage.removeItem(OTP_USER_INFO_KEY);
  }
}

export function clearOtpUserInfo() {
  sessionStorage.removeItem(OTP_USER_INFO_KEY);
}

export function clearAuthStorage() {
  clearAuthToken();
  clearOtpUserInfo();
}
